/**
 * Extrai a primeira mensagem de erro Zod (shape `flatten()`) de um campo específico,
 * a partir de uma resposta de erro Axios.
 *
 * Backend retorna 400 com `{ error, code?, details: { formErrors, fieldErrors } }`.
 * Esta função busca `details.fieldErrors[field][0]`.
 *
 * @param {unknown} err - erro do Axios (ou similar)
 * @param {string} field - nome do campo no schema
 * @returns {string | null} primeira mensagem ou null se não houver
 */
export function extractZodFieldError(err, field) {
  const errs = err?.response?.data?.details?.fieldErrors?.[field];
  return Array.isArray(errs) && errs[0] ? errs[0] : null;
}
